import { Component, OnInit, OnDestroy } from '@angular/core';
import { LiveTransmissionsService } from './live-transmissions.service';
import { IVideo } from '../../interfaces/videosByCategory';
import { Subscription, BehaviorSubject } from 'rxjs';
import { VIDEOS_AND_EVENTS_CATEGORIES } from 'src/app/modules/shared/enums/videos-and-events.enum';

@Component({
  selector: 'app-live-transmissions',
  templateUrl: './live-transmissions.component.html',
  styleUrls: ['./live-transmissions.component.scss']
})
export class LiveTransmissionsComponent implements OnInit, OnDestroy {
  liveTransmissionCategoryId = VIDEOS_AND_EVENTS_CATEGORIES.LIVE_TRANSMISSIONS;

  liveTransmissionCategoryItemsChange$ = new BehaviorSubject<IVideo[]>([]);

  isLoading: boolean = true;
  bannerItems: IVideo[] = [];

  private subscription: Subscription = new Subscription();

  constructor(private liveTransmissionsService: LiveTransmissionsService) {}

  ngOnInit(): void {
    this.subscription.add(
      this.liveTransmissionsService.liveData$.subscribe((data) => {
        this.isLoading = data.viewMode === 'loading';
        if (this.isLoading) return;

        this.bannerItems = data.items.slice(0, 3);

        this.liveTransmissionCategoryItemsChange$.next(
          data.showLiveTransmissionsCategory ? data.items : []
        );
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.liveTransmissionCategoryItemsChange$.complete();
  }
}
